export default __webpack_public_path__ + "static/media/Cv_Kpakpo_Akue_alternance_CP.331a4de5.pdf";